<template>
    <div>
        <Passengers :product="product" />

        <Divider color="lightGrey" bottomMargin="xxl" topMargin="xxl" thickness="1" />

        <Journeys
            type="Ferry"
            direction="column"
            :legs="product.Legs"
            :showDetailed="true"
            :showHeaderBackground="false"
            :showHeader="product.Legs.length > 1" />
    </div>
</template>
<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType } from 'vue';
    import { FerryProduct } from '@/api/Cart/cart.interfaces';
    import { capitalizeWords } from '@shared/utils/string';
    import Journeys from '@/components/shared/Journey/Journeys.vue';
    import Passengers from './Passengers/Passengers.vue';
    import Divider from '@ui/components/Divider/Divider.vue';

    export default defineComponent({
        name: 'FerryModalDetails',
        components: { Divider, Passengers, Journeys },
        methods: { capitalizeWords, t },
        props: {
            product: {
                type: Object as PropType<FerryProduct>,
                required: true,
            },
        },
    });
</script>
